<template>
  <v-container>
    <h1 class="text-center mb-8" >OBS Integration </h1>
      <div class="obs-content">
        <p class="text-center"> Hier gibt es aktuell die Möglichkeit die Sub/Bit Goals
        als Integration für OBS zu implementieren.</p>
        <p class="text-center"> Einfach den Link in OBS als Browserquelle
        importieren und es kann los gehen!</p>
        <p class="text-center"> Die Goals können unter "Settings" eingestellt werden.</p>
        <h3 class="text-center red--text text-decoration-underline mb-5">
          WICHTIG!!! Teile diese Links mit niemanden!</h3>
        <div class="custom-container3">
          <v-row dense align="center" class="mb-2">
            <v-col cols="12" sm="7" class="mt-2">
              <p class="text-center text-sm-left text-break mb-0">
                <span style="color: #00ffcd;">Sub Goal Link:</span>
                {{baseUrl}}/obs/daily_sub_goal/{{obstoken}}</p>
            </v-col>
            <v-col cols="6" sm="2">
              <v-btn color="secondary" outlined block @click="copyLink(`/obs/daily_sub_goal/${obstoken}`)">
                <v-icon left small>mdi-content-copy</v-icon>Kopieren
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3">
              <v-btn color="primary" block @click="editPrefix('daily_subgoal')">Prefix editieren</v-btn>
            </v-col>
          </v-row>
          <v-row dense align="center" class="mb-2">
            <v-col cols="12" sm="9" class="mt-2">
              <p class="text-center text-sm-left text-break mb-0">
                <span style="color: #00ffcd;">Daily Subs Link:</span>
                {{baseUrl}}/obs/daily_subs/{{obstoken}}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn color="secondary" outlined block @click="copyLink(`/obs/daily_subs/${obstoken}`)">
                <v-icon left small>mdi-content-copy</v-icon>Kopieren
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense align="center" class="mb-2">
            <v-col cols="12" sm="7" class="mt-2">
              <p class="text-center text-sm-left text-break mb-0">
                <span style="color: #00ffcd;">Bit Goal Link:</span>
                {{baseUrl}}/obs/daily_bit_goal/{{obstoken}}</p>
            </v-col>
            <v-col cols="6" sm="2">
              <v-btn color="secondary" outlined block @click="copyLink(`/obs/daily_bit_goal/${obstoken}`)">
                <v-icon left small>mdi-content-copy</v-icon>Kopieren
              </v-btn>
            </v-col>
            <v-col cols="6" sm="3">
              <v-btn color="primary" block @click="editPrefix('daily_bitgoal')">Prefix editieren</v-btn>
            </v-col>
          </v-row>
          <v-row dense align="center">
            <v-col cols="12" sm="9" class="mt-2">
              <p class="text-center text-sm-left text-break mb-0">
                <span style="color: #00ffcd;">Daily Bits Link:</span>
                {{baseUrl}}/obs/daily_bits/{{obstoken}}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn color="secondary" outlined block @click="copyLink(`/obs/daily_bits/${obstoken}`)">
                <v-icon left small>mdi-content-copy</v-icon>Kopieren
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <h3 class="pb-3">Einstellungen:</h3>
        <p>• Browserquelle hinzufügen</p>
        <p>• gewünschte URL einfügen</p>
        <v-img
          src="/img/obs/obs-settings-browsersource.png"
        ></v-img>
        <p class="pt-5">• Optional kann ein CSS Code hinzugefügt werden</p>
        <p class="ml-5">• beinflusst u.a. Schriftgröße/art</p>
        <p class="ml-5">• Gelber Hintergrund dient nur zur Präsentation und
          ist im CSS Code nicht enthalten</p>
        <div class="custom-container2 pb-5" >
          <p>Beispiel 1:</p>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-img
                class="mb-7 mx-auto"
                max-width="450"
                src="/img/obs/obs-example1.png"
              ></v-img>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn
              color="green"
              outlined
              :block="$vuetify.breakpoint.xsOnly"
              class="mx-4"
              @click="copyToClipboard(1)"
            >
              CSS kopieren
            </v-btn>
          </v-row>
        </div>
        <div class="custom-container2 pb-5" >
          <p>Beispiel 2:</p>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-img
                class="mb-7 mx-auto"
                max-width="450"
                src="/img/obs/obs-example2.png"
              ></v-img>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn
              color="green"
              outlined
              :block="$vuetify.breakpoint.xsOnly"
              class="mx-4"
              @click="copyToClipboard(2)"
            >
              CSS kopieren
            </v-btn>
          </v-row>
        </div>
        <div class="custom-container2 pb-5" >
          <p>Beispiel 3:</p>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-img
                class="mb-7 mx-auto"
                max-width="450"
                src="/img/obs/obs-example3.png"
              ></v-img>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn
              color="green"
              outlined
              :block="$vuetify.breakpoint.xsOnly"
              class="mx-4"
              @click="copyToClipboard(3)"
            >
              CSS kopieren
            </v-btn>
          </v-row>
        </div>
        <div class="custom-container2 pb-5" >
          <p>Beispiel 4:</p>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <v-img
                class="mb-7 mx-auto"
                max-width="450"
                src="/img/obs/obs-example4.png"
              ></v-img>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn
              color="green"
              outlined
              :block="$vuetify.breakpoint.xsOnly"
              class="mx-4"
              @click="copyToClipboard(4)"
            >
              CSS kopieren
            </v-btn>
          </v-row>
        </div>
          <v-snackbar
            v-model="copySuccess"
            timeout="1500"
            color="green"
          >
            CSS Code erfolreich kopiert!
          </v-snackbar>
      </div>
    <v-dialog
      v-model="dialog"
      :max-width="$vuetify.breakpoint.xsOnly ? '95vw' : '500px'"
    >
      <v-card>

        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="editedItem.var_content"
                    label="Prefix"
                    :rules="[v => !!v || 'Prefix is required']"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  sm="4"
                >
                  <h2>Als Beispiel: <span class="red--text">Prefix</span> 0/100 </h2>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :block="$vuetify.breakpoint.xsOnly"
            @click="close"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :block="$vuetify.breakpoint.xsOnly"
            @click="save"
            :loading="saving"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'OBSView',
  data: () => ({
    obstoken: '',
    baseUrl: '',
    copySuccess: false,
    dialog: false,
    valid: true,
    prefixe: '',
    saving: false,
    editedItem: {
    },
    editedIndex: -1,
  }),
  components: {
  },
  mounted() {
    this.baseUrl = window.location.origin;
    BackendService.loadObsToken({
      broadcasterid: this.$store.state.hostId,
    }).then((data) => {
      // console.log(data.data);const targetArray = data.data.find((item1) => item1.id === item.id);
      // console.log(targetArray);
      // console.log('Daten für OBS Token!');
      // console.log(data.data);
      this.obstoken = data.data.obs_token;
      this.prefixe = data.data.prefixe;
    });
  },
  methods: {
    copyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.copySuccess = true;
    },
    copyLink(path) {
      this.copyText(`${this.baseUrl}${path}`);
    },
    copyToClipboard(auswahl) {
      let cssConfig = 0;
      if (auswahl === 1) {
        cssConfig = `
h3 {
font-family: Arial !important;
}s
`;
      } else if (auswahl === 2) {
        cssConfig = `body {
color: yellow;
-webkit-text-stroke: 2px black;
text-shadow:
3px 3px 0 #000
;
}
h3 {
font-family: fantasy;
}
`;
      } else if (auswahl === 3) {
        cssConfig = `body {
color: white;
-webkit-text-stroke: 2px black;
}
h3 {
    font-family: "Courier New", monospace;
}
        `;
      } else if (auswahl === 4) {
        cssConfig = `body {
color: black;
-webkit-text-stroke: 2px white;
text-shadow:
    3px 3px 0 white;
}
h3 {
    font-family: "Georgia", serif;
}
        `;
      }

      this.copyText(cssConfig);
    },
    editPrefix(item) {
      // console.log(this.prefixe);
      for (let i = 0; i < this.prefixe.length; i += 1) {
        const currentItem = this.prefixe[i];
        if (currentItem.var_name === `prefix_${item}`) {
          // console.log(currentItem);
          this.editedItem = currentItem;
        }
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    save() {
      this.saving = true;
      // console.log(this.editedItem);
      BackendService.savePrefix({
        item: this.editedItem,
        db: this.$store.state.db,
      }).then((data) => {
        this.prefixe = data.data.prefixe;
      }).catch(() => {
        alert('nö!');
      }).finally(() => {
        this.saving = false;
        this.close();
      });
    },
  },
};
</script>

<style scoped>
.obs-content {
  max-width: 900px;
  margin: 0 auto;
}
</style>
